import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from "react-router-dom";
import { useServices } from '../../hooks/useServices';
import { useEventos } from '../../hooks/useEventos';
import { DualRing } from 'react-spinners-css';



export const LoadPayment = () => {

 const history = useHistory();
 const data = history.location.state;

 console.log('data recibida: ', data);
 const [licObjeto, setLicObjeto] = useState(data);
 const [loader, setLoader] = useState(true);
const [urlCreate, setUrlCreate] = useState();

const { seleccionaMonto, errorToken } = useEventos();

 const formEl = useRef();

 let reqLIC = {
  ...data
}


 const { getCODI, getToken, getExtId} = useServices();

 async function credenciales(){
  const urlPagos = await verUrl();
  const {value} = await getCODI(12);//aqui se dice el canal segun el id en base 5 att,  6 unefon, 12 ecommerce
  const myArray = value.split("|");

 
  const requestCredenciales = {
    "username": myArray[0],
    "channelId":21,//21 ecommerce , 18 att, 19 unefon
    "accessTokenId":myArray[1]
  }


  setUrlCreate(urlPagos+'/pss/createPSSPayment');
  obtenerToken(requestCredenciales, urlPagos+'/pss/getTokenPPSS')
}

const checkString = (objetoValidar)=>{
  let respuestaJson2;
    if (typeof objetoValidar === 'string' || objetoValidar instanceof String)
    // it's a string
    respuestaJson2 = objetoValidar;
    else{
      respuestaJson2 = JSON.stringify(objetoValidar);
    }
    return respuestaJson2
}

 async function verUrl(){
  const {value} = await getCODI(9);//aqui se obtiene la url de ppss
return value;
}

 const getIP = async() => {
    try {
      const response = await fetch('http://api.ipify.org/?format=json');
      if (!response.ok) {
        reqLIC.paymentSelfServiceRequest.ipAddress ="10.106.213.22";
        throw new Error(`Error! status: ${response.status}`);
      }
      const result = await response.json();
      reqLIC.paymentSelfServiceRequest.ipAddress = result.ip;
      //console.log('ip: ', result.ip);
    } catch (err) {
      console.log(err);
    }
  }

  const obtenerExtId = async() => {
    const dn = reqLIC.paymentSelfServiceRequest.dn;
    const monto = reqLIC.paymentSelfServiceRequest.chargeAmount;
    let tipoPago ="";

    if(reqLIC.paymentSelfServiceRequest.singlePaymentMethod == "02"){
      tipoPago = "CODI";
    }else{
      tipoPago="TARJETA"
    }

    seleccionaMonto(monto.toString());
    const response = await getExtId(dn,monto,tipoPago);
      if (response) {
        //console.log('extID: ',response.transaction_id);
        reqLIC.paymentSelfServiceRequest.transactionExtId = response.transaction_id;
      }else{
        //console.log('error al obtener transactionExtId: ', response);
         history.push("/nopay", {noPago: true});
       }
     
  }

  async function obtenerToken(payload, url){
      await getIP();
      await obtenerExtId();
      const response = await getToken(payload, url);
      
        if (response) {
          setLoader(false);
          reqLIC.paymentSelfServiceRequest.token= "Bearer" + response.token;
          const strReqLIC = JSON.stringify(reqLIC);
          setLicObjeto(strReqLIC);
          
          setTimeout(()=>{gotoLIC()},1000);
          
        }else{
          const respuestaJson2 =  checkString(response);
        console.log('error al obtener token: ', response);
         errorToken(respuestaJson2);
          history.push("/nopayrec", {noPago: true});
        }
  }

 const gotoLIC = ()=> {
    console.log('estado LIC: ', licObjeto);
    formEl.current.submit();
  }

  useEffect(() => {
    credenciales();
    
}, [data]);

return (
        <>
            { loader 
                ? 
                    <>
                        <div className="spinner"><DualRing color="#0568ae"/></div>
                    </>
                
                : <>
                     <div className="spinner"><DualRing color="#0568ae"/></div>
                      <div className="tituloPago">Conectando servicios de pago...</div>
                  
                      <form ref={formEl} action={urlCreate} method="POST" >
                        <input type="hidden" id="root" name="root" value={licObjeto}/>
                      </form>
                  </>
            }
      </>


      )
}
